(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mauchi-ai-disclosure"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mauchiAiDiscBound) return;
    window.__mauchiAiDiscBound = true;

    function place() {
      var label = document.querySelector('[data-mauchi-aidisc]');
      if (!label) return;
      var host = document.querySelector('media-gallery slideshow-container')
        || document.querySelector('media-gallery');
      if (!host) return;
      if (label.parentElement === host) return;
      host.appendChild(label);
      label.classList.add('is-overlay');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', place);
    } else {
      place();
    }

    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(place, 200);
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mauchi-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'mauchi-selected-size';

    function selectedSize() {
      var checked = document.querySelector(
        'fieldset input[type="radio"]:checked[value="S"], fieldset input[type="radio"]:checked[value="M"], fieldset input[type="radio"]:checked[value="L"], fieldset input[type="radio"]:checked[value="XL"]'
      );
      return checked ? checked.value : null;
    }

    document.querySelectorAll('[data-mauchi-bundle-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        try {
          var size = selectedSize();
          if (size) localStorage.setItem(KEY, size);
        } catch (e) {}
      });
    });

    // Restore size on the target product page
    try {
      var saved = localStorage.getItem(KEY);
      if (saved) {
        var input = document.querySelector(
          'fieldset input[type="radio"][value="' + saved + '"]'
        );
        if (input && !input.checked) input.click();
      }
    } catch (e) {}
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mauchi-buynow"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mauchi-buynow-wrap]').forEach(function (wrap) {
    var protId = wrap.dataset.protectionId ? Number(wrap.dataset.protectionId) : 0;
    var mainBtn = wrap.querySelector('[data-mauchi-buynow]');
    var plainBtn = wrap.querySelector('[data-mauchi-buynow-plain]');
    var label = wrap.querySelector('[data-mauchi-buynow-label]');

    function selectedVariantId() {
      var form = document.querySelector('product-form-component form, form[action*="/cart/add"]');
      if (!form) return null;
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (!idInput || !idInput.value) return null;
      return { id: Number(idInput.value), qty: Number((qtyInput && qtyInput.value) || 1) };
    }

    function go(withProtection) {
      var sel = selectedVariantId();
      if (!sel) return;
      var items = [{ id: sel.id, quantity: sel.qty }];
      if (withProtection && protId) items.push({ id: protId, quantity: 1 });
      mainBtn.disabled = true;
      var original = label ? label.innerHTML : '';
      if (label) label.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/checkout'; })
        .catch(function () { mainBtn.disabled = false; if (label) label.innerHTML = original; });
    }

    if (mainBtn) mainBtn.addEventListener('click', function () { go(true); });
    if (plainBtn) plainBtn.addEventListener('click', function () { go(false); });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mauchi-packpicker"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('.mauchi-packpicker');
    if (!root || root.dataset.built === 'true') return;
    root.dataset.built = 'true';

    const pieces = parseInt(root.dataset.pieces, 10) || 1;
    const colors = (root.dataset.colors || '').split('|').filter(Boolean);
    const sizes = (root.dataset.sizes || '').split('|').filter(Boolean);
    const rows = root.querySelector('.mauchi-packpicker__rows');
    const form = document.querySelector('form[action*="/cart/add"]');

    const radios = (option) =>
      [...document.querySelectorAll('input[type="radio"]')].filter((i) =>
        i.name.startsWith(option + '-')
      );

    const currentValue = (option) => {
      const hit = radios(option).find((i) => i.checked);
      return hit ? hit.value : '';
    };

    const selectVariant = (option, value) => {
      const hit = radios(option).find((i) => i.value === value);
      if (hit && !hit.checked) hit.click();
    };

    const property = (index, value) => {
      if (!form) return;
      const name = 'properties[' + root.dataset.labelPiece + ' ' + index + ']';
      let input = form.querySelector('input[name="' + CSS.escape(name) + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = value;
    };

    const buildSelect = (values, selected, label) => {
      const el = document.createElement('select');
      el.setAttribute('aria-label', label);
      values.forEach((v) => {
        const o = document.createElement('option');
        o.value = v;
        o.textContent = v;
        if (v === selected) o.selected = true;
        el.appendChild(o);
      });
      return el;
    };

    for (let i = 1; i <= pieces; i++) {
      const row = document.createElement('div');
      row.className = 'mauchi-packpicker__row';
      if (i === 1) row.classList.add('mauchi-packpicker__row--active');

      const num = document.createElement('span');
      num.className = 'mauchi-packpicker__num';
      num.textContent = '#' + i;

      const startColor = i === 1 ? currentValue('Color') || colors[0] : colors[0];
      const startSize = i === 1 ? currentValue('Size') || sizes[0] : sizes[0];

      const colorSelect = buildSelect(colors, startColor, root.dataset.labelColor + ' ' + i);
      const sizeSelect = buildSelect(sizes, startSize, root.dataset.labelSize + ' ' + i);

      const sync = () => {
        if (i === 1) {
          selectVariant('Color', colorSelect.value);
          selectVariant('Size', sizeSelect.value);
        }
        property(i, colorSelect.value + ' / ' + sizeSelect.value);
      };

      colorSelect.addEventListener('change', sync);
      sizeSelect.addEventListener('change', sync);

      row.append(num, colorSelect, sizeSelect);
      rows.appendChild(row);
      property(i, colorSelect.value + ' / ' + sizeSelect.value);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mauchi-quickpick"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mauchi-quickpick]').forEach(function (root) {
    var sheet = root.querySelector('[data-mauchi-quickpick-sheet]');
    var fab = root.querySelector('[data-mauchi-quickpick-open]');

    // Float the button over the main image, bottom-left, on every breakpoint.
    // (It therefore scrolls away with the gallery on mobile — that is the
    // intended behaviour: it belongs to the photo, not to the viewport.)
    function place() {
      var gallery = document.querySelector('media-gallery');
      var host = gallery ? gallery.querySelector('slideshow-container') || gallery : null;
      if (!host) return;
      // Already correctly placed — bail out so the observer below cannot loop.
      if (fab.parentElement === host) return;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      fab.classList.add('is-floating');
      host.appendChild(fab);
    }

    place();
    window.addEventListener('load', place);

    // Changing a variant makes Horizon re-render the gallery, which throws away
    // the button we injected. Watch the product section and re-attach it.
    var scope = document.querySelector('.product-information') || document.body;
    new MutationObserver(function () {
      place();
    }).observe(scope, { childList: true, subtree: true });

    // The fab is moved into the gallery, so query the label from the fab itself
    // rather than from `root` — it is no longer a descendant of root.
    var fabSize = fab.querySelector('[data-mauchi-quickpick-fabsize]');

    function sync() {
      var checked = document.querySelector(
        'fieldset input[type="radio"]:checked[value="S"], fieldset input[type="radio"]:checked[value="M"], fieldset input[type="radio"]:checked[value="L"], fieldset input[type="radio"]:checked[value="XL"]'
      );
      var val = checked ? checked.value : null;
      sheet.querySelectorAll('[data-mauchi-quickpick-size]').forEach(function (b) {
        b.classList.toggle('is-selected', b.dataset.mauchiQuickpickSize === val);
      });
      if (fabSize) fabSize.textContent = val || '–';

      // Mirror the selected colour. Single-value colour options are not
      // rendered as radios by the theme, so fall back to selecting the first.
      var colorBtns = sheet.querySelectorAll('[data-mauchi-quickpick-color]');
      if (colorBtns.length) {
        var checkedColor = null;
        colorBtns.forEach(function (b) {
          var input = document.querySelector(
            'fieldset input[type="radio"][value="' + b.dataset.mauchiQuickpickColor + '"]'
          );
          if (input && input.checked) checkedColor = b.dataset.mauchiQuickpickColor;
        });
        var selName = null;
        colorBtns.forEach(function (b, i) {
          var on = checkedColor
            ? b.dataset.mauchiQuickpickColor === checkedColor
            : i === 0;
          b.classList.toggle('is-selected', on);
          if (on) selName = b.dataset.mauchiQuickpickColor;
        });
        var nameEl = sheet.querySelector('[data-mauchi-quickpick-selname]');
        if (nameEl) nameEl.textContent = selName || '';
      }
    }

    // Keep the letter in step with the main variant picker too.
    sync();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') sync();
    });

    fab.addEventListener('click', function () {
      sync();
      sheet.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    });
    sheet.querySelectorAll('[data-mauchi-quickpick-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        sheet.hidden = true;
        document.documentElement.style.overflow = '';
      });
    });
    sheet.querySelectorAll('[data-mauchi-quickpick-color]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = document.querySelector(
          'fieldset input[type="radio"][value="' + b.dataset.mauchiQuickpickColor + '"]'
        );
        if (input && !input.checked) input.click();
        sheet.querySelectorAll('[data-mauchi-quickpick-color]').forEach(function (x) {
          x.classList.toggle('is-selected', x === b);
        });
        var nameEl = sheet.querySelector('[data-mauchi-quickpick-selname]');
        if (nameEl) nameEl.textContent = b.dataset.mauchiQuickpickColor || '';
      });
    });

    sheet.querySelectorAll('[data-mauchi-quickpick-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = document.querySelector(
          'fieldset input[type="radio"][value="' + b.dataset.mauchiQuickpickSize + '"]'
        );
        if (input && !input.checked) input.click();
        sheet.querySelectorAll('[data-mauchi-quickpick-size]').forEach(function (x) {
          x.classList.toggle('is-selected', x === b);
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mauchi-rating"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mauchi-rating]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.getElementById('mauchi-reviews');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mauchi-size-guide"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.mauchi-sizeguide').forEach(function (wrap) {
    // measurement/table dialog
    var modal = wrap.querySelector('[data-mauchi-sizeguide-modal]');
    wrap.querySelectorAll('[data-mauchi-sizeguide-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { modal.showModal(); });
    });
    wrap.querySelector('[data-mauchi-sizeguide-close]').addEventListener('click', function () { modal.close(); });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.close();
    });

    // fit-photos dialog (own popup: photo on top, size tabs at the bottom)
    var fit = wrap.querySelector('[data-mauchi-fitcheck-modal]');
    if (!fit) return;
    wrap.querySelectorAll('[data-mauchi-fitcheck-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { fit.showModal(); });
    });
    fit.querySelector('[data-mauchi-fitcheck-close]').addEventListener('click', function () { fit.close(); });
    fit.addEventListener('click', function (e) {
      if (e.target === fit) fit.close();
    });
    fit.querySelectorAll('[data-mauchi-size-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        fit.querySelectorAll('[data-mauchi-size-tab]').forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        fit.querySelectorAll('[data-mauchi-size-photo]').forEach(function (ph) {
          ph.hidden = ph.dataset.mauchiSizePhoto !== tab.dataset.mauchiSizeTab;
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mauchi-unitbadge"] && !Shopify.designMode) return;
  try {
    // Wrap the price and the badge in one row: price left, badge right.
  document.querySelectorAll('[data-mauchi-unitbadge]').forEach(function (badge) {
    var group = badge.closest('.group-block-content') || badge.parentElement;
    var price = group && group.querySelector('product-price');
    if (!price) return;
    var row = document.createElement('div');
    row.style.cssText =
      'display:flex;align-items:center;justify-content:space-between;gap:10px;width:100%;';
    price.parentNode.insertBefore(row, price);
    row.appendChild(price);
    row.appendChild(badge);
  });
  } catch(e) { console.error(e); }
})();

})();
